<template>
<div>
  <h1 class="title-h1">SPECIAL DEALS</h1>

<div class="spc-cont">
  <div class="spc-box" v-for="campaign in campaigns" :key="campaign.id">
    
    <div class="spc-details">
      
      <!--<div class="spc-img">
      <img :src="campaign.contentImageUrl">
    </div>-->
      <div class="spc-title"><h3><i class="fas fa-star"></i> {{ campaign.shortContent }}</h3></div>
      <h4>Details:</h4>
      <div v-html="campaign.longContent" class="spc-desc"></div>
      <div class="spc-name"><h2>{{ campaign.name }}</h2></div>
      <div class="spc-action">
        <div class="contact-info"><a class="res-call-button" :href="`tel:${campaign.phone}`"><div class="tr-res-detail-text"><i class="fa-solid fa-phone"></i> {{ campaign.phone }}</div></a></div>
        <div class="contact-info"><a class="res-call-button" @click="toggleReservations(true)"><div class="tr-res-detail-text"><i class="fas fa-utensils"></i> Make a Reservation</div></a></div>
        <div class="contact-info"><a class="res-call-button" @click="getRestaurant(campaign.user_property['Alias'])"><div class="tr-res-detail-text"><i class="fas fa-store"></i> Visit Restaurant Page </div></a></div>
      </div>
      <make-reservation :restaurant-name="campaign.user_property['Restaurant-Name']" :is-sidebar-active="resMakePopup" @closeSidebar="toggleReservations" :data-prop="null" />
    </div>
  </div>
</div>
</div>
</template>

<script>
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import MakeReservation from '../../components/reservations/MakeReservation'
export default {
  components: {
    swiper,
    swiperSlide,
    MakeReservation
  },
  metaInfo () {
    return {
      title: 'Special Deals - Turkish Restaurant',
      titleTemplate: '%s',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Turkish Restaurant is a unique portal where you can find the most delicious traditional Turkish dishes of the United States.'
        }
      ]
    }
  },
  data () {
    return {
      showSlider: false,
      campaigns: [],
      resMakePopup: false,
      showSlideContent: false,
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: (this.isMobile) ? 0 : 30,
        slidesPerGroup: 1,
        autoplay: {
          delay: 3000,
          disableOnInteraction: true
        },
        speed: 1500,
        loop: true,
        loopFillGroupWithBlank: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
    scrollY () {
      return this.$store.state.scrollY
    },
    isMobile () {
      return this.$store.state.api.isMobile
    },
    isInited () {
      return localStorage.getItem('isInited') === 'true'
    },
    isLoggedIn () {
      return this.$store.state.api.token_valid
    },
    showSearch () {
      return this.$store.state.api.showSearch
    },
    deliveryAddress () {
      return this.$store.state.api.deliveryAddress
    },
    specialSlideContents () {
      return this.$store.state.api.specialSlideContents
    },
    currentUser () {
      return this.$store.state.api.currentUser
    }
  },
  methods: {
    getContentList (cType) {

      this.$vs.loading()

      const payload = {
        contentType: cType,
        isHome: 1,
        page:'1',
        limit:'20'
      }

      this.$store.dispatch('api/contentList', payload)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },

    getCampaignList () {

      this.$vs.loading()

      const payload = {
        contentType: 'campaign',
        isHome: 1,
        page:'1',
        limit:'20'
      }

      this.$store.dispatch('api/campaignList', payload)
        .then((response) => {
          this.$vs.loading.close()
          this.campaigns = response.data.data
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })

    },

    toggleReservations (val = false) {
      this.resMakePopup = val
    },

    setSidebarWidth () {
      if (this.windowWidth < 992) {
        this.isFilterSidebarActive = this.clickNotClose = false
      } else {
        this.isFilterSidebarActive = this.clickNotClose = true
      }

    },

    // GRID VIEW - ACTIONS
    toggleFilterSidebar () {
      if (this.clickNotClose) return
      this.isFilterSidebarActive = !this.isFilterSidebarActive
    },
    toggleItemInWishList (item) {
      this.$store.dispatch('eCommerce/toggleItemInWishList', item)
    },
    additemInCart (item) {
      this.$store.dispatch('eCommerce/additemInCart', item)
    },
    getRestaurant (alias) {
      this.$vs.loading()
      this.$router.push({
        name: 'restaurant-products',
        params: {
          restaurant_id: String(alias),
          related_items: this.restaurantlist
        }})
    }
  },
  created () {
    this.setSidebarWidth()
    this.getContentList('special-slider')
    this.getCampaignList()
  },
  destroyed () {
    this.$store.commit('api/SET_SHOW_SEARCH', false)
  },
  mounted () {
    setTimeout(() => { this.showSlider = true }, 1000)
  },
  beforeMount () {
    this.$store.commit('api/SET_SHOW_SEARCH', true)
    this.$store.commit('TOGGLE_IS_SIDE_MENU_ACTIVE', false)
    this.$store.dispatch('updateSideMenuWidth', 'no-nav-menu')
    //this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
    //this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')

  }
}
</script>


<style lang="scss">
@import "../../assets/scss/home.scss";
.spc-cont {
  width: 100%;
  display: flex;
  gap: 10px;
  align-items: flex-start;
  justify-content: center;
  .spc-box {
    display: flex;
    flex-wrap: wrap;
    width: calc(33.33% - 20px);
    gap: 5px;
    border: 1px solid #ccc;
    border-radius: 3px;
    padding: 10px;
    align-items: flex-start;
    background-color: #f5f5f5;
    &:hover{
      background-color:#fff2ed;
      border-color:coral;
    }
    .spc-img {
      text-align: center;
      img {
        width: auto;
        max-height: 300px;
      }
      &::-webkit-scrollbar {
        width: 5px;
      }
      &::-webkit-scrollbar-track {
        background: #f1f1f1;
      }
      &::-webkit-scrollbar-thumb {
        background: #ccc;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #ccc;
      }
    }
    .spc-details {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      gap: 10px;
      h4 {
        margin: 0;
      }
      .spc-name {
        h2 {
          font-size:18px;
          margin: 0;
        }
      }
      .spc-title {
        h3 {
          color: #3c3c3c;
          font-weight: 900;
          display: flex;
          align-items: center;
          gap: 5px;
          margin: 0;
          i {
            font-size: 12px;
            padding: 5px;
            background-color: gold;
          }
        }
      }
      .spc-desc {
        max-height: 150px;
        min-height: 150px;
        overflow-y: scroll;
        overflow-x: hidden;
        padding: 10px;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 3px;

        &::-webkit-scrollbar {
          width: 3px;
        }
        &::-webkit-scrollbar-track {
          background: #f1f1f1;
        }
        &::-webkit-scrollbar-thumb {
          background: #ccc;
          border-radius: 25px;
        }
        &::-webkit-scrollbar-thumb:hover {
          background: #ccc;
        }
        p {
          margin:0;
          font-size:12px;
        }
      }
    }
    .spc-action {
      display: flex;
      flex-wrap: wrap;
      gap: 5px;
      .contact-info {
        width: 100%;
        text-align: center;
        background-color: #fff;
        border-radius: 3px;
      }
      .res-call-button {
        width: 100%;
        margin: 0;
        border-radius: 3px;
      }
    }
  }
}
@media (max-width: 980px) {
  .spc-cont {
    flex-wrap: wrap;
    justify-content: flex-start;
    .spc-box {
      width: calc(50% - 20px);
    }
  }
}
@media (max-width: 768px) {
  .spc-cont {
    gap:20px;
    .spc-box {
      .spc-img {
        width: 100%;
      }
      .spc-details {
        .spc-desc {
          margin-bottom: 5px;
        }
      }
      .spc-action {
        flex-direction: column;
        gap: 5px;
      }
    }
  }
}
@media (max-width: 500px) {
  .spc-cont {
    flex-wrap: wrap;
    .spc-box {
      width: 100%;
    }
  }
}
</style>
